import { useReducer } from 'react';
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import reducer, { defaultState, updateFieldCreator } from './reducer';
import {
  createMaCisCreator,
  setMaCisCreateErrorsCreator,
} from '../../../../../store/actionsCreators';
import AddChangeRequest from '../../../../../shared/ChangeRequest/Add/AddChangeRequest';

const AddMaChangeRequest = ({ errors, createChangeRequest, removeError }) => {
  const [state, dispatch] = useReducer(reducer, defaultState);

  return (
    <AddChangeRequest
      state={state}
      dispatch={dispatch}
      updateFieldCreator={updateFieldCreator}
      errors={errors}
      createChangeRequest={createChangeRequest}
      removeError={removeError}
      type="ma"
    />
  );
};

AddMaChangeRequest.propTypes = {
  errors: PropTypes.shape({
    description: PropTypes.string,
    files: PropTypes.string,
  }),
  createChangeRequest: PropTypes.func.isRequired,
  removeError: PropTypes.func.isRequired,
};

AddMaChangeRequest.defaultProps = {
  errors: {},
};

const mapStateToProps = ({ ma }) => ({
  errors: ma.cis.changeRequests.createErrors,
});

const mapDispatchToProps = (dispatch) => ({
  createChangeRequest: (payload, history) =>
    dispatch(createMaCisCreator('changeRequests', payload, history, true)),
  removeError: (payload) => dispatch(setMaCisCreateErrorsCreator('changeRequests', payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddMaChangeRequest);
